export const MAX_PROMO_CODES = 30;

export const TRANSLATIONS = {
  singleLabel: s__('PromoCode|Associated promo code'),
  multipleLabel: s__('PromoCode|Associated promo codes'),
  maxPromoCodesLabel: (maxPromoCodes: number) =>
    s__('PromoCode|%{maxPromoCodes} promo codes max.').i__({ maxPromoCodes }),
  addPromoCode: s__('PromoCode|Add promo code'),
  maxReachedError: (maxPromoCodes: number) =>
    s__(
      "PromoCode|You've reached the maximum of %{maxPromoCodes} promo codes. Remove one before adding a new one.",
    ).i__({ maxPromoCodes }),
  multiplePromoCodesInfo: s__(
    'PromoCode|Multiple promo codes can be associated with this item, but they are not cumulative. The end user can only choose one promo code to apply at checkout.',
  ),
  removePromoCode: s__('PromoCode|Remove promo code'),
};
